import script from "./PartnerRestaurantSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerRestaurantSelector.vue?vue&type=script&setup=true&lang=js"

import "./PartnerRestaurantSelector.vue?vue&type=style&index=0&id=0f6e457e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6e457e"]])

export default __exports__